import { ca } from '@cian/analytics';

import type { TMapPlatform } from '../../constants/map';
import type { TDistrictMapMode, TInfrastructurePoiType, TTaTab } from '../../types/infrastructure';

export interface ITrackOpenDistrictMap {
  newbuildingId?: number;
  platform: TMapPlatform;
}

function trackDistrictMapEvent({ label, newbuildingId, platform }: ITrackOpenDistrictMap & { label: string }) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'click',
    label,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      pageType: 'ListingCompareJK',
      siteType: platform,
    },
  });
}

/** Клик на «На карте» в ячейке «Район». */
export function trackOpenDistrictMap(params: ITrackOpenDistrictMap) {
  trackDistrictMapEvent({ ...params, label: 'Infrastructure' });
}

/** Выбор года на таймлайне будущего района. */
export function trackFutureYearChange({ year, ...params }: ITrackOpenDistrictMap & { year: number }) {
  trackDistrictMapEvent({ ...params, label: `district_future_year_${year}` });
}

/** Переключение таба транспортной доступности. */
export function trackTaTabChange({ tab, ...params }: ITrackOpenDistrictMap & { tab: TTaTab }) {
  trackDistrictMapEvent({ ...params, label: `district_ta_tab_${tab}` });
}

/** Открытие деталей оценки Дептранса. */
export function trackTaRatingOpen(params: ITrackOpenDistrictMap) {
  trackDistrictMapEvent({ ...params, label: 'district_ta_rate' });
}

/** Переход на методику Дептранса. */
export function trackTaSourceClick(params: ITrackOpenDistrictMap) {
  trackDistrictMapEvent({ ...params, label: 'district_ta_source' });
}

/** Клик по чипсу типа инфраструктуры на карте. */
export function trackInfrastructureTypeClick({
  newbuildingId,
  platform,
  type,
}: ITrackOpenDistrictMap & { type: TInfrastructurePoiType }) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Infrastructure',
    action: 'click_object_type_sopr',
    label: type,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      pageType: 'ListingCompareJK',
      siteType: platform,
    },
  });
}

/** Клик по пункту панели «Дополнительно». */
export function trackMapServiceClick({
  mode,
  newbuildingId,
  platform,
}: ITrackOpenDistrictMap & { mode: Exclude<TDistrictMapMode, 'default'> }) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Infrastructure',
    action: 'click_sopr',
    label: mode === 'future' ? 'future_button' : 'index_button',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      pageType: 'ListingCompareJK',
      siteType: platform,
    },
  });
}
